exports.updateContactPhone = async (state, locationDoc, phoneNumber, program) => {
  return state.dal.location.updateContactPhone(state, locationDoc, phoneNumber, program)
}
